import React, { useCallback, useState, createContext } from 'react';

import initCornerstone3D from '@/context/cornerstone/initCornerstone';

interface CornerstoneProviderProps {
  children: React.ReactNode;
}

export interface CornerstoneContextType {
  isInitialized: boolean;
  isLoading: boolean;
  initialize: () => Promise<void>;
  errorMessage: string | null;
}

export const CornerstoneContext = createContext<CornerstoneContextType>({
  isInitialized: false,
  isLoading: false,
  initialize: async () => Promise.resolve(),
  errorMessage: null,
});

export const CornerstoneProvider: React.FC<CornerstoneProviderProps> = ({
  children,
}) => {
  const [ isInitialized, setIsInitialized ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState<string | null>(null);

  const initialize = useCallback(async () => {
    if (isInitialized || isLoading) {
      return;
    }
    try {
      setIsLoading(true);
      await initCornerstone3D();
      setIsInitialized(true);
      setErrorMessage(null);
    }
    catch (error) {
      console.error('Error initializing Cornerstone3D:', error);
      setIsInitialized(false);
      setErrorMessage(`Error initializing Cornerstone3D: ${error instanceof Error ? error.message : String(error)}`);
    }
    finally {
      setIsLoading(false);
    }
  }, [ isInitialized, isLoading ]);

  return (
    <CornerstoneContext.Provider value={ { isInitialized, isLoading, initialize, errorMessage } }>
      { children }
    </CornerstoneContext.Provider>
  );
};
